<template>
  <li v-link="{ name: 'exercise', params: { id: this.id }}" class="exercise" transition="reveal">
    {{title}}
  </li>
</template>

<script>
import gsap from 'gsap'

export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    subexercises: {
      type: Array,
      default () {
        return []
      }
    },
    delay: {
      type: Number,
      default: 0.2
    },
    y: {
      type: Number,
      default: -30
    },
    duration: {
      type: Number,
      default: 0.5
    }
  },
  transitions: {
    reveal: {
      enter (el, done) {
        gsap.set(this.$el, {opacity: 0, y: this.y})
        gsap.to(el, this.duration, {opacity: 1, y: 0, onComplete: done, delay: this.delay * this.index})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
li {
  padding: 1rem;
  cursor: pointer;
  font-size: 5rem;
  font-weight: bold;

  &:hover {
    opacity: .5
  }
}
</style>


// WEBPACK FOOTER //
// Exercise.vue?b402e8ee